// Reliable CDN & Local Assets - Migrated from Dropbox
// We use high-performance CDNs for media and the /public/assets folder for UI

// Logo relocated to /public/assets for production reliability
export const LOGO_URL = "/assets/logo.svg";

// UI Videos - Migrated to high-performance Pexels CDN
export const ANIMATED_LOGO_VIDEO_URL = "https://player.vimeo.com/external/370331493.sd.mp4?s=7b9963554d8bc073400301931393663a7536e84d&profile_id=139&oauth2_token_id=57447761";
export const FEATURED_STORY_VIDEO_URL = "https://player.vimeo.com/external/451717369.sd.mp4?s=99360c70094055272372f4f2a7a8d5f3d640989f&profile_id=165&oauth2_token_id=57447761";

// Fallback Images - Optimized Unsplash CDN links
export const PLACEHOLDER_IMAGE = "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=800&auto=format&fit=crop&q=60";
export const KDRAMA_PLACEHOLDER = "https://images.unsplash.com/photo-1593784991095-a20506948430?w=800&auto=format&fit=crop&q=60";
export const BLOG_PLACEHOLDER = "https://images.unsplash.com/photo-1499750310159-52f0f837ce62?w=800&auto=format&fit=crop&q=60";